import apiClient from "../../http";
import {
  SUBSCRIPTION_ACTIVATE_REQUEST,
  SUBSCRIPTION_ACTIVATE_SUCCESS,
  SUBSCRIPTION_ACTIVATE_FAIL,
  SUBSCRIPTION_PAY_REQUEST,
  SUBSCRIPTION_PAY_SUCCESS,
  SUBSCRIPTION_PAY_FAIL,
  SUBSCRIPTION_DETAILS_REQUEST,
  SUBSCRIPTION_DETAILS_SUCCESS,
  SUBSCRIPTION_DETAILS_FAIL,
} from "../Constants/SubscriptionConstants";

// ACTIVATE SUBSCRIPTION (Protected API - Requires Auth)
export const activateSubscription = (subscription) => async (dispatch) => {
  return new Promise(async (resolve) => {
    try {
      dispatch({ type: SUBSCRIPTION_ACTIVATE_REQUEST });

      const { data } = await apiClient.post(
        `subscription/activate`,
        subscription,
        { requiresAuth: true } // This tells Axios to add the token
      );

      dispatch({
        type: SUBSCRIPTION_ACTIVATE_SUCCESS,
        payload: { item: data },
      });
      resolve(data);
    } catch (error) {
      const message = error.response?.data?.message || error.message || error;
      dispatch({ type: SUBSCRIPTION_ACTIVATE_FAIL, payload: message });
    }
  });
};

// PAY SUBSCRIPTION
export const paySubscription = (payment) => async (dispatch) => {
  try {
    dispatch({ type: SUBSCRIPTION_PAY_REQUEST });

    const result = await apiClient.post(`/subscription/pay`, payment, {
      requiresAuth: true,
    });
    dispatch({ type: SUBSCRIPTION_PAY_SUCCESS, payload: result.data });
  } catch (error) {
    const message = error.response?.data?.message || error.message;
    dispatch({ type: SUBSCRIPTION_PAY_FAIL, payload: message });
  }
};

// GET SUBSCRIPTION DETAILS
export const getSubscriptionDetails = (businessId) => async (dispatch) => {
  try {
    dispatch({ type: SUBSCRIPTION_DETAILS_REQUEST });

    const result = await apiClient.get(
      `/subscription/${businessId}`,

      {
        requiresAuth: true,
      }
    );

    dispatch({
      type: SUBSCRIPTION_DETAILS_SUCCESS,
      payload: result.data,
    });
  } catch (error) {
    const message = error.response?.data?.message || error.message || error;
    dispatch({ type: SUBSCRIPTION_DETAILS_FAIL, payload: message });
  }
};
